<script>
  import { isDev, Slider } from '$client';
  import Item from './Item.svelte';
  export let data = [];
  export let type = 'gray';
  export let header = 'Новости';
  export let buttons = true;
  export let url = '';

  const media = [
    { size: 99999, gap: 40, count: 4 },
    { size: 1199.98, gap: 20, count: 3 },
    { size: 991.98, gap: 15, count: 2 },
    { size: 767.98, gap: 15, count: 1 },
  ];

  const testData = {
    get: key => testData[key][Math.floor(Math.random() * testData[key].length)],
    names: [
      'Ульяновская область ждёт «Мусорную войну»',
      'Бюджет канул в «Чёрную дыру»',
      'ЕСПЧ изучил подмосковный мусор',
      'Бюджет канул в «Чёрную дыру»',
    ],
    types: ['blog', 'news', 'video'],
    desc: 'Сразу две «мусорные» компании борются за отходы Новоспасского района Ульяновской области. Глава района Александр Горбунов официально попросил местные организации — от судов до детсадов — поддержать один из двух проектов. Конкурирующая компания считает это превышением должностных полномочий и готовит обращение в прокуратуру. При этом в областном правительстве недовольны обоими соперниками, а эксперты констатируют, что отходов в районе может не хватить и на одну компанию.',
  };

  const createReview = () => ({
    id: 1,
    attributes: {
      header: testData.get('names'),
      type: testData.get('types'),
      date: '2016-03-12',
      description: Math.random() > 0.5 ? testData.desc : '',
      url: '/',
      cardImg: {
        data: {
          id: 0,
          attributes: {
            url: '',
            alternativeText: '',
          },
        },
      },
    },
  });

  $: if (!data.length && isDev()) data = new Array(10).fill({}).map(createReview);
</script>

<Slider {url} {buttons} {header} {type} component={Item} {data} {media} />
